import { createActionName } from "../../../utility"

export const reducerName = "journeyEvents"

export const JOURNEY_EVENT = createActionName(reducerName, "JOURNEY_EVENT")

export default {
    reducerName,
}
